module.exports = __webpack_public_path__ + "static/media/banner-desktop.81d439e5.jpg";